export default __webpack_public_path__ + "island6.7dc52fd363f6119c2b6fe2a59fc2b20e.png";